export class OfferPriority {
    clubCode: string;
    offerKeys: string;

    constructor(clubCode: string, offerKeys: string) {
        this.clubCode = clubCode;
        this.offerKeys = offerKeys;
    }
}
